<app-common-page-breadcrumbs [navigationData]="navigationData" [pageTitle]="title"></app-common-page-breadcrumbs>
<!-- <div *ngIf="!enableLoader"></div> -->
<div >
  <span class="mobile-header hidden-xs ml-4 p-2 d-none">{{'heading.MyBHPTeamMembers' | cxTranslate}}</span>
</div>
<div *ngIf="enableLoader" class="align-items-center" id="loader"></div>
<div class="container py-4 text-center strong  text-secondary" *ngIf="noData && !enableLoader">{{'home.contracts.Noresults' | cxTranslate }}<br></div>
<!-- <div class="text-center strong  text-primary mb-5 pb-4" *ngIf="noData">{{'home.contracts.Noresults' | cxTranslate }}<br></div> -->
<!-- <div *ngIf="enableLoader"></div> -->

<div class="container d-flex flex-column justify-content-center py-4">
<table *ngIf="bhpteam && !enableLoader">
<thead role="rowgroup" *ngIf="!noData" >
  <tr role="row" class="bg-table-header border-bottom" *ngIf="!noData">
    <th role="columnheader" class=' p-7'>{{'heading.Name' | cxTranslate}}</th>
    <th role="columnheader" class=' p-7'>{{'heading.Email' | cxTranslate}}</th>
    <th role="columnheader" class=' p-7'>{{'heading.Mobile' | cxTranslate}}</th>
    <th role="columnheader" class=' p-7'>{{'heading.Role' | cxTranslate}}</th>
  </tr>
</thead>
<tbody role="rowgroup" >
  <tr role="row" (click)="navigateToDetails(i)" class="bg-white border-bottom" *ngFor="let i of bhpteam">
    <td class=' p-7' [attr.data-label]= "'heading.Name' | cxTranslate" role="cell">{{i.name | titlecase}}</td>
    <td class=' p-7' [attr.data-label]= "'heading.Email' | cxTranslate" ><span *ngIf="i.email === ''">&nbsp;</span><a ngxCopyPaste #cp="copy" href="mailto:{{i.email}}">{{i.email}}</a><i  (click)="cp.copy();copyText('copy')" *ngIf="i.email !== ''" class="fas fa-copy ml-3 text-gray-450 icon-style copy-icon"></i></td>
    <td class=' p-7' [attr.data-label]= "'heading.Mobile' | cxTranslate" role="cell"><span *ngIf="i.mobileNumber === ''">&nbsp;</span><a  *ngIf="i.mobileNumber !== ''" href="tel:{{i.mobileNumber}}">{{i.mobileNumber}} <img src="/images/revertedphone.svg" alt="Phone"
      class="ml-2 icon-style desktop-icon"><img src="/images/revertedphoneOrange.svg" alt="Phone"
      class="ml-2 icon-style mobile-icon"></a>
    <td class=' p-7' [attr.data-label]= "'heading.Role' | cxTranslate" role="cell">{{i.role ? i.role : " "}}</td>
      <!-- <td><p ngxCopyPaste #cp="copy">Lorem ipsum</p>
 
        <p (click)="cp.copy()">Copy</p></td> -->
  </tr>
</tbody>
</table>
</div>
